import { memo } from 'react';
import type { IconProps } from './types';

const FilterIcon = ({ iconLabel, color }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.75"
            height="12.75"
            viewBox="0 0 12.75 12.75"
            data-icon={iconLabel}
            color={color}
        >
            <path
                className="a"
                fill="currentColor"
                d="M6.375,8.925A1.913,1.913,0,0,1,8.182,10.21l.031-.005h0l.074,0h3.825a.638.638,0,0,1,.074,1.271l-.074,0H8.288a.629.629,0,0,1-.106-.009,1.913,1.913,0,0,1-3.614,0l-.031.005h0l-.074,0H.638A.638.638,0,0,1,.563,10.2l.074,0H4.463a.629.629,0,0,1,.106.009A1.913,1.913,0,0,1,6.375,8.925Zm0,1.275a.638.638,0,1,0,.638.638A.638.638,0,0,0,6.375,10.2ZM1.913,4.463A1.913,1.913,0,0,1,3.72,5.747l.031-.005h0l.074,0h8.288a.638.638,0,0,1,.074,1.271l-.074,0H3.825A.629.629,0,0,1,3.719,7,1.913,1.913,0,1,1,1.913,4.463Zm0,1.275a.638.638,0,1,0,.638.638A.638.638,0,0,0,1.913,5.738ZM8.925,0a1.913,1.913,0,0,1,1.807,1.285l.031-.005h0l.074,0h1.275a.638.638,0,0,1,.074,1.271l-.074,0H10.838a.629.629,0,0,1-.106-.009,1.913,1.913,0,0,1-3.614,0l-.031.005h0l-.074,0H.638A.638.638,0,0,1,.563,1.279l.074,0H7.013a.629.629,0,0,1,.106.009A1.913,1.913,0,0,1,8.925,0Zm0,1.275a.638.638,0,1,0,.638.638A.638.638,0,0,0,8.925,1.275Z"
            />
        </svg>
    );
};

export default memo(FilterIcon);
